// This file will be enqueued in the FacetWP timeline features template.

function features_timeline_column_height() {
	setTimeout( function() {
		var timeline_cards = document.querySelectorAll( '.feature-timeline__single' );

		if ( timeline_cards.length === 0 ) return;

		var column_heights = [ 0, 0 ];
		var timeline = document.querySelector( '.facetwp-template' );
		var timeline_height = 0;
		var remSize = parseFloat( getComputedStyle( document.querySelector( 'html' ) )[ 'font-size' ] );
		var windowWidthPx = document.documentElement.clientWidth;
		var windowWidth = windowWidthPx / remSize;

		if ( windowWidth < 40 ) timeline_height = "100%";

		if ( windowWidth >= 40 ) {
			function odd_or_even( integer ) {
				return ( integer & 1 ) ? 1 : 0;
			}
			timeline_cards.forEach( function( card, index ) {
				column_heights[ odd_or_even( index ) ] = column_heights[ odd_or_even( index ) ] + card.offsetHeight;
			} );
			timeline_height = Math.max.apply( Math, column_heights ) + 200 + "px";
		}


		timeline.style.height = timeline_height;
	}, 500 );
}

window.addEventListener( 'resize', features_timeline_column_height );

( function( $ ) {

	$( document ).on( 'facetwp-loaded', features_timeline_column_height );

}( jQuery ) );
